import "../component-library/patterns/alert/alert.js";
import "../component-library/patterns/select/select.js";

import Dropdown from "./common/dropdown.js";

const Factory = {
  ".js-dropdown": Dropdown,
};

Object.keys(Factory).forEach((key) => {
  Array.from(document.querySelectorAll(key)).map(
    (element) => new Factory[key](element),
  );
});
